import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './ui/CtaButton';
import { tomos } from '../data/content';
export function TomosSection() {
  return <section aria-labelledby="tomos" className="border-y-2 border-blush bg-blush-soft" data-id="element-230" data-mp="1p5wkr0d3kheu">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-231" data-mp="xce0c045bx9c">
        <Reveal data-id="element-232" data-mp="xe78jjueqpjg">
          <SectionHeading id="tomos" title="Qué encontrarás dentro" data-id="element-233" data-mp="xeqs14zphlzl" />
        </Reveal>

        <ol className="mt-4 grid gap-2.5 md:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="11e99fqsbjexo">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-blush border-t-4 border-t-coral bg-white p-3.5" data-id="element-235" data-mp="16ff6g0t0hod0" data-mpi={i}>
              <h3 className="flex items-start gap-2 font-display text-[0.9rem] font-black uppercase leading-tight text-ink sm:text-[0.95rem]" data-id="element-236" data-mp="2mqj5pfomkb84">
                <CheckCircle2Icon size={16} className="mt-0.5 flex-shrink-0 text-coral" strokeWidth={2.5} data-id="element-237" data-mp="2qnfld5zw69bl" />
                {tomo.title}
              </h3>
              <p className="mt-1.5 font-body text-[0.76rem] leading-snug text-slate sm:text-[0.8rem]" data-id="element-238" data-mp="2cofya2s122hj">
                {tomo.desc}
              </p>
              <p className="mt-1 font-body text-[0.76rem] leading-snug text-slate sm:text-[0.8rem]" data-id="element-239" data-mp="27q62bpyhaxuv">
                {tomo.extraDesc}
              </p>
              <p className="mt-auto pt-2.5 font-script text-lg leading-tight text-coral sm:text-xl" data-id="element-240" data-mp="1yx2hgwli7iq7">
                {tomo.tag}
              </p>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} className="mt-5 text-center" data-id="element-241" data-mp="1tw502m8bispr">
          <h3 className="font-display text-base font-black uppercase text-ink sm:text-xl" data-id="element-242" data-mp="1oxk08nwzab1u">
            Mira todo lo que incluye
          </h3>
          <p className="mx-auto mt-1.5 max-w-2xl font-body text-[0.8rem] leading-snug text-slate sm:text-sm" data-id="element-243" data-mp="1ac63qjocl1li">
            Dentro encontrarás explicaciones, ejemplos, actividades,
            vocabulario, frases y herramientas creadas para ayudarte a convertir
            conceptos del coreano en conocimientos que puedas comprender,
            practicar y repasar.
          </p>
          <div className="mt-3 flex justify-center" data-id="element-244" data-mp="15f5y29veu0ux">
            <CtaButton size="lg" data-id="element-245" data-mp="1t2e2kpl0l5vw">
              ¡SÍ! QUIERO APRENDER COREANO DESDE CERO
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>;
}